// @ts-nocheck 95d6b380
import * as selectors from './boxSlideShowSelectors';

export { selectors };
